// Tiny dependency-free confetti burst using the Web Animations API.

const COLORS = ['#2dd4bf', '#8b5cf6', '#d946ef', '#fbbf24', '#5eead4']

export function fireConfetti(container: HTMLElement = document.body): void {
  for (let i = 0; i < 44; i++) {
    const c = document.createElement('div')
    c.style.cssText = `position:fixed;width:8px;height:8px;z-index:90;pointer-events:none;
      background:${COLORS[i % COLORS.length]};
      left:${35 + Math.random() * 30}%;top:32%;
      border-radius:${Math.random() > 0.5 ? '99px' : '2px'};`
    container.appendChild(c)
    const dx = (Math.random() - 0.5) * 520
    const dy = 220 + Math.random() * 400
    const rot = Math.random() * 720
    c.animate(
      [
        { transform: 'translate(0,0) rotate(0deg)', opacity: 1 },
        { transform: `translate(${dx}px,${dy}px) rotate(${rot}deg)`, opacity: 0 },
      ],
      { duration: 1100 + Math.random() * 700, easing: 'cubic-bezier(.2,.6,.4,1)' },
    )
    window.setTimeout(() => c.remove(), 1900)
  }
}
